export default __webpack_public_path__ + "static/media/star.fd6a4859.svg";